// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTabbedPageView-Tab_cls1__Im3Gv","cls2":"VeloTabbedPageView-Tab_cls2__ojfml VeloTabbedPageView-Tab_cls1__Im3Gv"};